import { render, staticRenderFns } from "./TrainingCourseList.vue?vue&type=template&id=2b15d69b&"
import script from "./TrainingCourseList.vue?vue&type=script&lang=js&"
export * from "./TrainingCourseList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports